export enum DepartmentAdministrationTabs {
  USERS = 'users',
  LABELS = 'labels',
  SETTINGS = 'settings',
}
